module.exports = __webpack_public_path__ + "static/media/flag.471cb415.glb";